import {
    Field,
    FieldSet,
    modernizeSchema,
    ModernizeSchemaOptions,
    SchemaForm
} from "universal-schema/lib"
import { jsonSchemaV001 } from "universal-schema/lib/0.0.1/schema_json"
import { jsonSchemaV002 } from "universal-schema/lib/0.0.2/schema_json"
import { jsonSchemaV003 } from "universal-schema/lib/0.0.3/schema_json"
import { jsonSchemaV004 } from "universal-schema/lib/0.0.4/schema_json"
import type { UiSchema } from "@rjsf/core"
import { JSONSchema7 } from "json-schema"
import { APIAppInstanceModel } from "../API/AppInstanceModel"
import {
    APIAppTemplateModel,
    MarketplaceTemplateModel
} from "../API/AppTemplateModel"

export function modernizeSchemaIfNeeded(
    schema: JSONSchema7,
    uiSchema?: UiSchema,
    description?: FieldSet | Field,
    options?: ModernizeSchemaOptions
): SchemaForm {
    return schema.$schema !== undefined &&
        [
            jsonSchemaV001.$id,
            jsonSchemaV002.$id,
            jsonSchemaV003.$id,
            jsonSchemaV004.$id
        ].includes(schema.$schema)
        ? modernizeSchema(schema, description, options)
        : { schema, uiSchema: uiSchema ?? {} }
}

export const jobInputModernizeOptions = {
    enableMarkdown: true,
    enableCopyTextButton: true,
    descriptionInUiHelp: true
}

export const marketplaceJobInputModernizeOptions = {
    ...jobInputModernizeOptions,
    enableCopyTextButton: false
}

export const jobOutputModernizeOptions = {
    enableMarkdown: false,
    enableCopyTextButton: true,
    descriptionInUiHelp: true
}

export const marketplaceJobOutputModernizeOptions = {
    ...jobOutputModernizeOptions,
    enableCopyTextButton: false
}

export function getAppSchema(
    instance: APIAppInstanceModel,
    template: APIAppTemplateModel | MarketplaceTemplateModel,
    marketplaceMode: boolean
): { input: SchemaForm; output: SchemaForm } {
    return {
        input: modernizeSchemaIfNeeded(
            instance.inputSchema ?? template.inputSchema,
            instance.inputUiSchema ?? template.inputUiSchema,
            template.metadata.parameter_description?.inputs,
            marketplaceMode
                ? marketplaceJobInputModernizeOptions
                : jobInputModernizeOptions
        ),
        output: modernizeSchemaIfNeeded(
            instance.outputSchema ?? template.outputSchema,
            instance.outputUiSchema ?? template.outputUiSchema,
            template.metadata.parameter_description?.outputs,
            marketplaceMode
                ? marketplaceJobOutputModernizeOptions
                : jobOutputModernizeOptions
        )
    }
}
